import { Link } from "react-router-dom"
import { useAuthGate } from "@/lib/authGate"
import { Beam } from "../ds"

const DocIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 3h7l5 5v13H7z" />
    <path d="M14 3v5h5" />
    <path d="M9.5 16h5M9.5 13h5" />
  </svg>
)
const GavelIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 20h10" />
    <path d="M9 20v-4" />
    <path d="M6 12l6-6 5 5-6 6z" />
  </svg>
)
const OrderIcon = (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <rect x="4" y="5" width="16" height="14" rx="2" />
    <path d="M8 10h8M8 14h5" />
  </svg>
)

export type Door = "research" | "notice" | "appeal"

/**
 * The four doors on Home (Home-v4). Research, Analyse a notice and Appeal or not choose what the
 * box above does: ask a question, take a notice, or take an order. The order simulators are their
 * own pages.
 */
export function Doors({ door, onDoor }: { door: Door; onDoor: (door: Door) => void }) {
  const { signedIn, requireLogin } = useAuthGate()
  const simulator = (
    <>
      <div className="nr-door-top">
        {OrderIcon}
        <span className="nr-door-num">04</span>
      </div>
      <div className="nr-door-title">See how the order could read</div>
      <div className="nr-door-desc">Nira drafts the order both ways so you can see what you are replying to.</div>
      <div className="nr-door-foot">Free sample case · real drafts are Pro</div>
    </>
  )
  return (
    <nav className="nh-doors" aria-label="What Nira can do">
      <button type="button" className="nr nr-door" data-state={door === "research" ? "on" : "rest"} aria-pressed={door === "research"} onClick={() => onDoor("research")}>
        <div className="nr-door-top">
          <Beam state="static" label={null} />
          <span className="nr-door-num">01</span>
        </div>
        <div className="nr-door-title">Research</div>
        <div className="nr-door-desc">The law and the decisions for and against, weighed for your State.</div>
        <div className="nr-door-foot">Free · no credit card needed</div>
      </button>
      <button
        type="button"
        className="nr nr-door"
        data-state={door === "notice" ? "on" : "rest"}
        aria-pressed={door === "notice"}
        // A notice goes into a case file under the reader's account: a guest signs in first.
        onClick={() => (signedIn ? onDoor("notice") : requireLogin("upload"))}
      >
        <div className="nr-door-top">
          {DocIcon}
          <span className="nr-door-num">02</span>
        </div>
        <div className="nr-door-title">Analyse a notice</div>
        <div className="nr-door-desc">Drop a DRC-01 or SCN: what it turns on, the rupees, the reply-by date.</div>
        <div className="nr-door-foot">Free · your first one in full, then Pro</div>
      </button>
      <button
        type="button"
        className="nr nr-door"
        data-state={door === "appeal" ? "on" : "rest"}
        aria-pressed={door === "appeal"}
        onClick={() => (signedIn ? onDoor("appeal") : requireLogin("upload"))}
      >
        <div className="nr-door-top">
          {GavelIcon}
          <span className="nr-door-num">03</span>
        </div>
        <div className="nr-door-title">Appeal or not</div>
        <div className="nr-door-desc">Drop an order: grounds, pre-deposit, the deadline, the cost.</div>
        <div className="nr-door-foot">Free · the first order's entry reading, then Pro</div>
      </button>
      {signedIn ? (
        <Link className="nr nr-door" data-state="rest" to="/simulator">{simulator}</Link>
      ) : (
        // The simulators need an account: a guest is asked to sign in, then taken there.
        <button type="button" className="nr nr-door" data-state="rest" onClick={() => requireLogin("simulator", "/simulator")}>{simulator}</button>
      )}
    </nav>
  )
}
